import Swiper from "swiper";

$(function () {
    let swiper = new Swiper('.uq-slider', {
        slidesPerView: 1.1,
        spaceBetween: 20,
        speed: 500,
        grabCursor: true,
        breakpoints: {
            375: {
                slidesPerView: 1.2,
                spaceBetween: 20
            },
            768: {
                slidesPerView: 1.8,
                spaceBetween: 20
            },
            992: {
                slidesPerView: 2.2,
                spaceBetween: 20
            }
        }
    });
});